module.exports = __webpack_public_path__ + "posture/static/img/leg_x_left.6d5e8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/abnormal/leg_x_left.png
// module id = c+bA
// module chunks = 1